// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"bG-z","tooltipWrapper":"cG-z","icon":"dG-z","tooltip":"eG-z","content":"fG-z"};